import { LocalStorageHelper } from '../helpers/localstorage/localstoragehelper';
import { SessionStorageHelper } from '../helpers/sessionstorage/sessionstoragehelper';

export class Setting {
    readonly settingName: string;
    settingValue: unknown;

    constructor(Name: string, Value: unknown) {
        this.settingName = Name;
        this.settingValue = Value;
    }
}

export class TenantSettings {
    IsLoggedIn: boolean = false;
    IsChatAppEnabled: boolean = false;
    AppUrl: string = '';
    AssetUrl: string = '';
}



export class AppIdentity {
    private static readonly _identityKey = "_idty";
    private static readonly _impersonationKey = "im_idty";

    userId: number = 0;
    name: string = '';
    tenantId: number = 0;
    languageId: number = 0;
    dateFormat: string = '';
    timeZone: string = '';
    timeFormat: string = '';
    language: string = '';
    uiDirection: string = 'ltr'; // Default to left-to-right
    colorScheme: string = 'default';
    themeLayout: string = 'default'; //default to light theme
    themeMode:string= 'system';
    sourceId: number = 0;
    unibaseId: string = '';
    isAdmin: boolean = false;
    latd: string = '';
    lgtd: string = '';
    warehouseId: number = 0;
    secDataEnabled: boolean = false;
    deviceId: number = 0;
    isRestrictedUser: boolean = false;
    installedAppId: number = 0;
    photoUrl: string = '';
    appUrl: string = '';
    partitionId: number = 0;
    partitionName: string = '';
    partitionFromDate: string = '';
    partitionToDate: string = '';
    settings: Setting[] = [];
    parentUserId: number = 0;
    fromDate: string = '';
    toDate: string = '';
    globalDateRangeTypeId: number = 0;
    isRedirectToChat: boolean = false;
    tenant: TenantSettings = new TenantSettings();
    email: string = '';
    phone: string = '';

    private static activeIdentity: AppIdentity | null = null;

    static getSetting(settingName: string): unknown | undefined {
        return this.activeIdentity?.settings.find(e => e.settingName === settingName)?.settingValue;
    }

    static setActiveIdentity(identity: AppIdentity | null): void {
        const localStorageHelper = LocalStorageHelper.Instance();
        if (identity === null) {
            localStorageHelper.removeItem(this._identityKey);
            SessionStorageHelper.clearToken();
        } else {
            const str = JSON.stringify(identity);
            localStorageHelper.setItem(this._identityKey, str);
        }
        this.activeIdentity = identity;
    }

    static getActiveIdentity(): AppIdentity | null {
        //for testing purposes
        //const _activeIdentity = this.getDummyIdentity();
        //this.activeIdentity = _activeIdentity;
        if (this.activeIdentity === null) {
            const localStorageHelper = LocalStorageHelper.Instance();
            const identityStr = localStorageHelper.getItem(this._identityKey);
            if (identityStr !== '' && identityStr !== null) {
                this.activeIdentity = JSON.parse(identityStr) as AppIdentity;
            }
        }
        return this.activeIdentity;
    }

    static getDummyIdentity(): AppIdentity {
        let dummyIdentity = new AppIdentity();
        dummyIdentity.userId = 1;
        dummyIdentity.colorScheme = 'default';
        dummyIdentity.themeLayout = 'default';
        dummyIdentity.themeMode = 'dark';
        dummyIdentity.appUrl = '';
        dummyIdentity.name = 'Dummy User';
        dummyIdentity.tenantId = 1;
        dummyIdentity.languageId = 1;
        dummyIdentity.dateFormat = 'MM/DD/YYYY';
        dummyIdentity.timeZone = 'UTC';
        dummyIdentity.timeFormat = '12-hour';

        return dummyIdentity;
    }

    static setIdentity(cvalue: string): void {
        const localStorageHelper = LocalStorageHelper.Instance();
        localStorageHelper.setItem(this._identityKey, cvalue);
    }

    static getIdentity(): string | null {
        const localStorageHelper = LocalStorageHelper.Instance();
        return localStorageHelper.getItem(this._identityKey);
    }

    static setImpesonation(cvalue: string): void {
        const localStorageHelper = LocalStorageHelper.Instance();
        localStorageHelper.setItem(this._impersonationKey, cvalue);
    }

    static getImpesonation(): string | null {
        const localStorageHelper = LocalStorageHelper.Instance();
        return localStorageHelper.getItem(this._impersonationKey);
    }

    static updateTenantLoginStatus(isLoggedIn: boolean): void {
        const activeIdentity = this.activeIdentity;
        if (activeIdentity) {
            activeIdentity.tenant.IsLoggedIn = isLoggedIn;
            this.setActiveIdentity(activeIdentity);
        }
    }
}
